import { Outlet } from "react-router-dom";
import Header from "./Sidebar";
import { useSelector } from "react-redux";
import useWindowSize from "../hooks/useWindowSize";
const Layout = () => {
  const { isMobile } = useSelector((state) => state.layout);
  const { width } = useWindowSize();
  const isMobileView = width <= 885;
  return (
    <>
      <Header />
      <div
        className={`main-part ${
          isMobileView
            ? "small-screen"
            : !isMobileView && isMobile
            ? "mobile-screen"
            : width >= 885 && !isMobile && "desktop-screen"
        }`}
      >
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
